export default "/images/vendor/flag-icons/flags/4x3/gw.svg?9bc2271a9dcb2ec3e78c455c4d71f50f";